import { render, staticRenderFns } from "./DialogDDA.vue?vue&type=template&id=a2107628"
import script from "./DialogDDA.vue?vue&type=script&lang=js"
export * from "./DialogDDA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports